const INITIAL_STATE = {
    countries: [],
    meats: [],
    message_options: [],
    message_restaurant_options: []
}
export const optionReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'options':
            return action.payload
        default:
            return state     
    }
}
export default optionReducer;